module.exports = __webpack_public_path__ + "static/img/title4.34e37ed3.png";